import React, { useEffect, useState } from 'react';
import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
//import { BetaRight } from '../../components/beta-header';
import { LayoutDashboard } from '../../layouts/layout-dashboard';
import { CardCombination } from '../../components/card-combination';
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useAxios } from '../../hooks/useAxios';
import { Console } from '../../services/platform-api';
import { Preloader } from '../../components/preloader';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { GetUser } from '../../services/platform-user';
import { GetActiveConnections } from '../../data/workato/get-active-connections';
import { ImgBanner } from '../../assets/images/icons/icons';
import WFSettings from '../../data/platform/workflow_settings.json';
import { ArchieImg, ArchieMedImg, ArcosImg, ArcelImg, ArchanaImg } from '../../assets/images/images';
import { useDecision } from '@optimizely/react-sdk';

const Home = (props) => {
  const { data: data, error: error, fetchNow: fetchNow } = useAxios();
  const { data: votesData, fetchNow: getAllVotes } = useAxios();
  const { fetchNow: recordNewsInterest } = useAxios();

  const [combinations, setCombinations] = useState([]);
  const [recommendedCombinations, setRecommendedCombinations] = useState();
  const [step, setStep] = useState(1);
  const [totalVotes, setTotalVotes] = useState(0);
  const [gotVotes, setGotVotes] = useState(false);
  const [activeCombos, setActiveCombos] = useState([]);
  const [totalonnections, setTotalonnections] = useState(null);
  const [userID] = useSessionStorage('userId', '');
  const [shouldCollapse, setShouldCollapse] = useState(false);
  const user = GetUser(userID);
  const handleClose = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);
  const [activeKey, setActiveKey] = useState('0');
  const { cons_data } = GetActiveConnections();
  const [loadingRecomm, setLoadingRecomm] = useState(true);
  const [loadingActive, setLoadingActive] = useState(true);
  const [initialTestFlag] = useDecision('initial_test_flag');

  useEffect(() => {
    // control the active accordian
    if (loadingActive) {
      setActiveKey('0');
    } else if (activeCombos.length === 0 && !loadingActive) {
      setActiveKey(null);
    } else if (activeCombos.length > 0) {
      setActiveKey('0');
      Console('OPEN THE ACCORDIAN ');
    } else {
      setActiveKey(null);
    }

    // get the news item cookie.
    const localStorageValue = window.localStorage.getItem('shouldCollapseNews');
    if (localStorageValue) {
      setShouldCollapse(true);
    } else {
      setShouldCollapse(false);
    }

    if (step === 1 && data === null) {
      Console('  get combo data');
      // grab the workflows for the given solutions
      fetchNow(`/api/platform/combinations`, 'GET', null, false); // get all combinations
      setStep(2);
    } else if (step === 2 && data) {
      Console('  step 2', data);

      // exclude the coming soon WF
      const active_combo = data.filter((combo) => combo.status !== 'coming_soon' && combo.enabled);

      // get a count of all our physical connections
      const all_cons_authorised = cons_data.filter((connection) => connection.authorization_status === 'success');
      Console('  cons_data --', cons_data);
      Console('  all_cons_authorised 2', all_cons_authorised);
      Console('  all_cons_authorised length', all_cons_authorised.length);
      setTotalonnections(all_cons_authorised.length);

      // loop through the active combos and filter cons_data based on the provider and authorization status
      active_combo.forEach((combo) => {
        let cons_filtered = [];

        // check if the provider is Xero
        if (WFSettings.connectors_comboIDs.xero.includes(combo.id)) {
          cons_filtered = cons_data.filter(
            (connection) => connection.provider === 'xero' && connection.authorization_status === 'success',
          );
          if (cons_filtered.length > 0) {
            combo.authed = true;
          } else {
            combo.authed = false;
          }
        } else if (WFSettings.connectors_comboIDs.outlook.includes(combo.id)) {
          // Outlook
          cons_filtered = cons_data.filter(
            (connection) => connection.provider === 'outlook' && connection.authorization_status === 'success',
          );
          if (cons_filtered.length > 0) {
            combo.authed = true;
          } else {
            combo.authed = false;
          }
        } else if (WFSettings.connectors_comboIDs.google_drive.includes(combo.id)) {
          // G drive
          cons_filtered = cons_data.filter(
            (connection) => connection.provider === 'google_drive' && connection.authorization_status === 'success',
          );
          if (cons_filtered.length > 0) {
            combo.authed = true;
          } else {
            combo.authed = false;
          }
        } else if (WFSettings.connectors_comboIDs.google_sheets.includes(combo.id)) {
          // G sheets
          cons_filtered = cons_data.filter(
            (connection) => connection.provider === 'google_sheets' && connection.authorization_status === 'success',
          );
          if (cons_filtered.length > 0) {
            combo.authed = true;
          } else {
            combo.authed = false;
          }
        } else if (combo.id === 8 || combo.id === 10 || combo.id === 11) {
          // basic wf's - these have no connectors default to true
          combo.authed = true;
        }
        Console('  cons_filtered for ' + combo.id + ' ' + combo.authed, cons_filtered);
      });
      Console('  active_combo out : ', active_combo);

      setCombinations(active_combo);

      // extract the recommended WF
      const rec_combo = data.filter((combo) => combo.recommended === true && combo.enabled);
      Console('  rec_combo out : ', rec_combo);
      setRecommendedCombinations(rec_combo);

      setStep(0);
    }

    // get and set our total votes
    if (!gotVotes) {
      getAllVotes(`/api/platform/votes`, 'GET', null, false); // get all votes
      setGotVotes(true);
    }
    if (votesData && votesData.length > 0) {
      Console('  combo_vote : ', votesData);
      setTotalVotes(votesData.length);
    }
  }, [fetchNow, getAllVotes, step, gotVotes, data, votesData, totalVotes, activeCombos, combinations, loadingActive]);

  if (error) {
    console.log('error', error);
    return null;
  }
  const handleActiveToggle = (eventKey) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const handleAccordionToggle = (eventKey) => {
    console.log('eventKey', eventKey);

    console.log('clicked', shouldCollapse);
    setShouldCollapse(!shouldCollapse);
  };
  const handleNewsInterest = () => {
    const payload = {
      topic: 'First Topic',
    };
    localStorage.setItem('shouldCollapseNews', true);
    recordNewsInterest(`/api/platform/marketing`, 'POST', payload, false);
    setShouldCollapse(true);
    setShowModal(true);
  };

  const handleDismiss = () => {
    localStorage.setItem('shouldCollapseNews', true);
    setShouldCollapse(true);
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Your GPT powered financial analyst.</Modal.Title>
        </Modal.Header>
        <iframe
          id="my-iframe"
          src="https://landing.arcanum.ai/accelerate-platform-new-feature"
          height="700"
          width="100%"
          title="Latest News"
        ></iframe>
        <Modal.Footer>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      <div className="dashboard">
        <header>
          <Container fluid>
            <Row>
              <Col lg={8} className="px-5">
                <Breadcrumb content="Home"></Breadcrumb>

                <h1>
                  {initialTestFlag.enabled ? 'Howdy' : 'Welcome'} {user?.Name}
                </h1>
              </Col>
              <Col lg={4} className="px-5">
                {/* <BetaRight /> */}
              </Col>
            </Row>
          </Container>
        </header>
        <LayoutDashboard>
          <Row>
            <Col lg={12} className="flex">
              {/* News frame */}
              <Accordion activeKey={shouldCollapse ? null : '0'} onSelect={handleAccordionToggle}>
                <Accordion.Item className="home-accordian-item" eventKey="0">
                  <Accordion.Header>New workflow now available!</Accordion.Header>
                  <Accordion.Body style={{ height: '205px' }}>
                    <div className="banner-content">
                      <Row>
                        <Col lg={7}>
                          <h3 className="white-text">Your GPT powered financial analyst</h3>
                          Harness the power of GPT to get faster insights for easier financial reporting.
                          <br />
                          <br />
                          <Button variant="primary" type="submit" onClick={handleNewsInterest} className="mt-3 px-4">
                            Explore!
                          </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            onClick={handleDismiss}
                            className="btn-trans mt-3 px-4"
                          >
                            Dismiss
                          </Button>
                        </Col>
                        <Col lg={5}>
                          <img src={ImgBanner} height="138" className="right ps-5 me-5" />
                          <img className="right" src={ArchieMedImg} title="Archie" alt="Archie" width="150" />
                        </Col>
                      </Row>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              {/* active connections - stats */}
              <br />
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Body>
                    <Row>
                      <Col className="text-center eggplant-200-bg p-2 m-2">
                        <label htmlFor="name" className="label">
                          Active Connections
                        </label>
                        <br />
                        <br />
                        <h1 className="larger">
                          {totalonnections === null ? <div className="pulse_loader">.</div> : totalonnections}
                        </h1>
                      </Col>
                      <Col className="text-center eggplant-100-bg p-2 m-2">
                        <label htmlFor="name" className="label">
                          Combinations Available
                        </label>
                        <br />
                        <br />
                        <h1 className="larger">
                          {!combinations ? <div className="pulse_loader">.</div> : combinations.length}
                        </h1>
                      </Col>
                      <Col className="text-center light_grey_bg bg p-2 m-2">
                        <label htmlFor="name" className="label">
                          Coming Soon Votes
                        </label>
                        <br />
                        <br />
                        <h1 className="larger">
                          {totalVotes === 0 ? <div className="pulse_loader">.</div> : totalVotes}
                        </h1>
                      </Col>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <br />
              {/* active combos */}

              <Accordion activeKey={activeKey} defaultActiveKey={'0'} onSelect={() => handleActiveToggle('0')}>
                {/* <Accordion defaultActiveKey={'0'} activeKey={activeRecipeCount > 0 ? '0' : 0}> */}
                <Accordion.Item eventKey="0" className="home_ccordian_white">
                  <Accordion.Header>Active Combinations</Accordion.Header>
                  <Accordion.Body>
                    <Row className="">
                      {loadingActive && (
                        <>
                          <Preloader smallscreen={true} /> <br />
                          <br />
                          <br />
                        </>
                      )}
                      {combinations ? (
                        <>
                          {combinations.map((combo, key) => {
                            return (
                              <CardCombination
                                uniq_key={key}
                                combinationData={combo}
                                onlyactive={true}
                                activeCombos={activeCombos}
                                setActiveCombos={setActiveCombos}
                                totalCount={combinations.length}
                                setLoadingDone={setLoadingActive}
                              />
                            );
                          })}
                          <Col xxlg={6} xl={6} lg={6} md={12}>
                            <a href="/solution/1" rel="noopener">
                              <div className="card card-combinations px-4 ">
                                <div className="d-flex  align-items-center p-2 m-2 card-body">
                                  <div className="row ">
                                    <div className="col-lg-12 ">
                                      <h1>+ New Combination</h1>
                                      <a href="/solution/1/Finance" id="nav_arcos" rel="noopener">
                                        <img className="assistant_thumb" src={ArchieImg} title="Archie" alt="Archie" />
                                      </a>
                                      <a href="/solutions" id="nav_arcos" rel="noopener">
                                        <img
                                          className="assistant_thumb inactive_img"
                                          src={ArcosImg}
                                          title="Arcos"
                                          alt="Arcos"
                                        />
                                      </a>
                                      <a href="/solutions" id="nav_arcos" rel="noopener">
                                        <img
                                          className="assistant_thumb inactive_img"
                                          src={ArcelImg}
                                          title="Arcel"
                                          alt="Arcel"
                                        />
                                      </a>
                                      <a href="/solutions" id="nav_arcos" rel="noopener">
                                        <img
                                          className="assistant_thumb inactive_img"
                                          src={ArchanaImg}
                                          title="Archana"
                                          alt="Archana"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="card-footer">
                                  Get Started &nbsp;
                                  <img src="/static/media/icon-go.a37206748ad8f7cfae7d7d0189ab7b39.svg" alt="Go" />
                                </div>
                              </div>
                            </a>
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <br />
              {/* recommended combos */}
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0" className="home_ccordian_white">
                  <Accordion.Header>Recommended Combinations</Accordion.Header>
                  <Accordion.Body>
                    {/* {loading && <Preloader smallscreen={true} />} */}
                    <Row>
                      {loadingRecomm && (
                        <>
                          <Preloader smallscreen={true} /> <br />
                          <br />
                          <br />
                        </>
                      )}
                      {recommendedCombinations
                        ? recommendedCombinations.map((combo, key) => {
                            return (
                              <CardCombination
                                key={key}
                                uniq_key={key}
                                combinationData={combo}
                                recommended={true}
                                activeCombos={activeCombos}
                                totalCount={recommendedCombinations.length}
                                setLoadingDone={setLoadingRecomm}
                              />
                            );
                          })
                        : null}
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <br />
            </Col>
          </Row>
        </LayoutDashboard>

        <Nav nav1on="" nav2on="" nav3on="" {...props} />
      </div>
    </>
  );
};

export { Home };
